import { ROUTE_TITLE_PREFIX } from "../misc";

export type FormType = "feedback";

export interface GAStandardEventDescription {
    page: string;
    location_label: string;
    location_type: string;

    page_path?: string;
    previous_page_path?: string;
    previous_page?: string;

    filter_options?: string;
    map_location?: string;
    search_keyword?: string;

    category_breadcrumb?: string;
    provider_to_compare?: string;

    form_type?: FormType;
    form_experience_score?: number;
    form_experience_label?: string;
    form_comment?: string;

    label: string;
}

export interface GAEvent<EventName, EventDescription> {
    name: EventName;
    description: EventDescription;
}

export type EventName = "page_visit" | "click" | "filter" | "search" | "form_submit";
export type EventPage =
    | "home"
    | "exploreProviders"
    | "providerInfo"
    | "providerComparison"
    | "providerSelectToCompare"
    | "faq"
    | "about";

export type EventLocationType =
    | "button"
    | "map"
    | "link_button"
    | "filter_input"
    | "text_input"
    | "toggle_info_button"
    | "toggle_graph_button"
    | "toggle_table_button"
    | "tab"
    | "page_location"
    | "form";

const eventSend = <Name, Desc>(event: GAEvent<Name, Desc>): void => {
    if (!window["gtag"]) {
        console.warn(`Google Analytics might not be installed properly with ${event.name} event`, event);
        return;
    }

    if (!event.description) {
        console.warn("GA event description must exist");
        return;
    }

    window["gtag"]("event", event.name, event.description);
};

export const eventGtag = (event: GAEvent<EventName, GAStandardEventDescription>) => {
    eventSend(event);
};

const EventPageEnumToEventPage: Record<EventPage, string> = {
    exploreProviders: ROUTE_TITLE_PREFIX.SEARCH_PAGE,
    home: ROUTE_TITLE_PREFIX.HOME,
    providerComparison: ROUTE_TITLE_PREFIX.PROVIDER_COMPARE,
    providerInfo: ROUTE_TITLE_PREFIX.PROVIDER_INFO,
    providerSelectToCompare: ROUTE_TITLE_PREFIX.PROVIDER_SELECT_TO_COMPARE,
    faq: ROUTE_TITLE_PREFIX.FAQ,
    about: ROUTE_TITLE_PREFIX.ABOUT
};

export const appEventGTag = ({
    page,
    previousPage,
    eventName,
    eventLabel,
    eventLocationType,

    eventPagePathname,
    eventPreviousPagePathname,
    eventLocationLabel,

    filterOptions,
    mapLocation,
    searchKeyword,

    categoryBreadcrumb,
    providerToCompare,

    formType,
    formExperienceLabel,
    formExperienceScore,
    formComment
}: {
    page: EventPage;
    eventName: EventName;
    eventLabel: string;
    eventLocationType: EventLocationType;
    eventLocationLabel: string;
    eventPagePathname?: string;
    previousPage?: string;
    eventPreviousPagePathname?: string;

    filterOptions?: string;
    mapLocation?: string;
    searchKeyword?: string;

    categoryBreadcrumb?: string;
    providerToCompare?: string;

    formExperienceLabel?: string;
    formExperienceScore?: number;
    formComment?: string;
    formType?: FormType;
}) => {
    eventGtag({
        name: eventName,
        description: {
            label: eventLabel,
            page: EventPageEnumToEventPage[page],
            location_type: eventLocationType,
            location_label: eventLocationLabel,
            previous_page: previousPage,
            page_path: eventPagePathname,
            previous_page_path: eventPreviousPagePathname,
            filter_options: filterOptions,
            map_location: mapLocation,
            search_keyword: searchKeyword,
            category_breadcrumb: categoryBreadcrumb,
            provider_to_compare: providerToCompare,

            form_comment: formComment,
            form_experience_label: formExperienceLabel,
            form_experience_score: formExperienceScore,
            form_type: formType
        }
    });
};
